import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { HttpRequest } from "@smithy/protocol-http";
import { resolvedPath } from "./resolve-path";
export function requestBuilder(input, context) {
  return new RequestBuilder(input, context);
}
export var RequestBuilder = /*#__PURE__*/function () {
  function RequestBuilder(input, context) {
    _classCallCheck(this, RequestBuilder);
    this.input = input;
    this.context = context;
    this.query = {};
    this.method = "";
    this.headers = {};
    this.path = "";
    this.body = null;
    this.hostname = "";
    this.resolvePathStack = [];
  }
  _createClass(RequestBuilder, [{
    key: "build",
    value: function () {
      var _build = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$this$context$e, hostname, _yield$this$context$e2, protocol, port, basePath, _iterator, _step, resolvePath;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.context.endpoint();
              case 2:
                _yield$this$context$e = _context.sent;
                hostname = _yield$this$context$e.hostname;
                _yield$this$context$e2 = _yield$this$context$e.protocol;
                protocol = _yield$this$context$e2 === void 0 ? "https" : _yield$this$context$e2;
                port = _yield$this$context$e.port;
                basePath = _yield$this$context$e.path;
                this.path = basePath;
                _iterator = _createForOfIteratorHelper(this.resolvePathStack);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    resolvePath = _step.value;
                    resolvePath(this.path);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                return _context.abrupt("return", new HttpRequest({
                  protocol: protocol,
                  hostname: this.hostname || hostname,
                  port: port,
                  method: this.method,
                  path: this.path,
                  query: this.query,
                  body: this.body,
                  headers: this.headers
                }));
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function build() {
        return _build.apply(this, arguments);
      }
      return build;
    }()
  }, {
    key: "hn",
    value: function hn(hostname) {
      this.hostname = hostname;
      return this;
    }
  }, {
    key: "bp",
    value: function bp(uriLabel) {
      var _this = this;
      this.resolvePathStack.push(function (basePath) {
        _this.path = "".concat(basePath !== null && basePath !== void 0 && basePath.endsWith("/") ? basePath.slice(0, -1) : basePath || "") + uriLabel;
      });
      return this;
    }
  }, {
    key: "p",
    value: function p(memberName, labelValueProvider, uriLabel, isGreedyLabel) {
      var _this2 = this;
      this.resolvePathStack.push(function (path) {
        _this2.path = resolvedPath(path, _this2.input, memberName, labelValueProvider, uriLabel, isGreedyLabel);
      });
      return this;
    }
  }, {
    key: "h",
    value: function h(headers) {
      this.headers = headers;
      return this;
    }
  }, {
    key: "q",
    value: function q(query) {
      this.query = query;
      return this;
    }
  }, {
    key: "b",
    value: function b(body) {
      this.body = body;
      return this;
    }
  }, {
    key: "m",
    value: function m(method) {
      this.method = method;
      return this;
    }
  }]);
  return RequestBuilder;
}();